import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { DeacParamList } from '../../../typings/Params';
import { useAuth } from '../../../context/Auth';
import ActingBodiesDropdown from '../../../components/Dropdowns/ActingBodiesDropdown';

interface Props {
    filters: DeacParamList['VacancyLevels'];
    setFilters: React.Dispatch<React.SetStateAction<DeacParamList['VacancyLevels']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<DeacParamList, 'VacancyLevels'>>>();
    const { user: authenticatedUser } = useAuth();

    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);


    const handleCleanFilter = () => {
        setTextFilter('');
        setActingBodyId(0);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });
    };

    if (!authenticatedUser) {
        return <></>;
    }

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            {authenticatedUser.permissions.deac_manage_all_acting_bodies_vacancy_level &&
                <ActingBodiesDropdown
                    includeAllOption={true}
                    value={actingBodyId}
                    setValue={setActingBodyId}
                    zIndex={7} />
            }
        </Filters>
    );
}

export default Filter;
